import { useEffect } from "react";

const TITLE = "Diagnóstico gratis — Studio Web VIP";
const DESCRIPTION =
  "Estás pagando por leads. Instalamos el sistema para que ninguno se pierda. Diagnóstico gratis de 15 minutos en Miami.";

const META_TAGS: { attr: "name" | "property"; key: string; content: string }[] = [
  { attr: "name", key: "description", content: DESCRIPTION },
  { attr: "property", key: "og:title", content: TITLE },
  { attr: "property", key: "og:description", content: DESCRIPTION },
  { attr: "property", key: "og:type", content: "website" },
  { attr: "name", key: "twitter:card", content: "summary_large_image" },
  { attr: "name", key: "twitter:title", content: TITLE },
  { attr: "name", key: "twitter:description", content: DESCRIPTION },
];

/** Sets <title>, lang and SEO/social meta tags in the document head. */
export function useDocumentMeta(): void {
  useEffect(() => {
    document.title = TITLE;
    document.documentElement.lang = "es";
    META_TAGS.forEach(({ attr, key, content }) => {
      let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    });
  }, []);
}
